import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
import { initHeadMeta } from "./utils/headMeta";
initHeadMeta();
initMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-278" data-mp="26a27z0trvvl1" />);
}